import { DatePicker } from '@fluentui/react'
import React from 'react';
import { useTranslation } from 'react-i18next';

const AiExportCsvBody = (props) => {
    const [t] = useTranslation();
    const today = new Date();

    const datePickerStyles = { root: { maxWidth: 300, marginTop: 15 } };

    const fromDateFunction = (date) => {
        props.setErrorMessage("");
        props.setFilterObj({ ...props.filterObj, fromDate: date });
        props.setValues({ ...props.values, fromDate: date });
        props.setErrors({ ...props.errors, fromDate: null });
    };

    const toDateFunction = (date) => {
        props.setErrorMessage("");
        props.setFilterObj({ ...props.filterObj, toDate: date });
        props.setValues({ ...props.values, toDate: date });
        props.setErrors({ ...props.errors, toDate: null });
    };

    return (
        <div className="close-study-container">
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <DatePicker
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        value={props.filterObj.fromDate}
                        name="fromDate"
                        style={datePickerStyles}
                        onSelectDate={fromDateFunction}
                        placeholder="dd-mmm-yyyy"
                        maxDate={today}
                        label={
                            <span>
                                {t("export-csv.upload-date-from")}
                                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                            </span>
                        }
                        formatDate={(date) => {
                            const day = date.getDate().toString().padStart(2, "0");
                            const month = new Intl.DateTimeFormat("en", {
                                month: "short",
                            }).format(date);
                            const year = date.getFullYear();
                            return `${day}-${month}-${year}`;
                        }}
                        textField={{
                            errorMessage: props.errors.fromDate
                                ? props.errors.fromDate
                                : undefined,
                        }}
                    />
                </div>
                <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                    <DatePicker
                        className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        value={props.filterObj.toDate}
                        name="toDate"
                        onSelectDate={toDateFunction}
                        placeholder="dd-mmm-yyyy"
                        maxDate={today}
                        formatDate={(date) => {
                            const day = date.getDate().toString().padStart(2, "0");
                            const month = new Intl.DateTimeFormat("en", {
                                month: "short",
                            }).format(date);
                            const year = date.getFullYear();
                            return `${day}-${month}-${year}`;
                        }}
                        label={
                            <span>
                                {t("export-csv.upload-date-to")}
                                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
                            </span>
                        }
                        textField={{
                            errorMessage: props.errors.toDate
                                ? props.errors.toDate
                                : undefined,
                        }}
                    />
                </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div style={{ marginTop: "15px", fontSize: "13px" }}>
                    <strong>Note:</strong> A maximum of 45 days of data can be exported per request.
                </div>
                <div className="form-mt-10 custom-required-error-msg">
                    {props.errorMessage}
                </div>
            </div>
        </div>
    );
}

export default AiExportCsvBody
